//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QueryBuilder from "query-builder-vue";
import GroupOperatorSlot from "./components/GroupOperatorSlot.vue";
import GroupCtrlSlot from "./components/GroupCtrlSlot.vue";
import RuleSlot from "./components/RuleSlot.vue";

import BackendServices from "@/services/backend-services.js";
import draggable from "vuedraggable";
import Select from "./components/Select.vue";
import Multiselect from "./components/Multiselect.vue";
import Date from "./components/Date.vue";
import Int from "./components/Int.vue";
import Decimal from "./components/Decimal.vue";
import Boolean from "./components/Boolean.vue";
import Textbox from "./components/Textbox.vue";
import PivotTable from "./components/PivotTable.vue";
import { Feedback } from "@/utils/notify-toaster.js";
import { LoadingModal } from "@/utils/loading-modal.js";
import { Dialog } from "quasar";

const aggregatorFields = [
  { key: 0, val: "value", label: "Valor" },
  { key: 1, val: "count", label: "Contagem" },
  { key: 2, val: "avg", label: "Média" },
  { key: 3, val: "sum", label: "Soma" },
  { key: 4, val: "max", label: "Máximo" },
  { key: 5, val: "min", label: "Minímo" },
];
export default {
  name: "DataBuilder",
  components: {
    draggable,
    QueryBuilder,
    GroupOperatorSlot,
    GroupCtrlSlot,
    RuleSlot,
    PivotTable,
  },
  created: async function () {
    this.$store.commit("setDatePickerState", false);
    this.lastSession = localStorage.getItem("databuilderQuery");
    if (this.$route.redirectedFrom) {
      let response = await BackendServices.getSavedQueryByToken(
        this.$route.redirectedFrom.split("/").pop()
      );
      if (response.data) {
        this.lastSession = JSON.stringify(response.data.save_object);
        localStorage.setItem("databuilderQuery", this.lastSession);
      } else {
        this.lastSession = null;
        Feedback.error("Link inválido.");
      }
    }
    this.getQueryableTables();
  },
  updated: function () {
    let lsState = JSON.parse(localStorage.getItem("databuilderQuery"));
    if (!lsState.filters && !!lsState.queryColumns && this.lastSession) {
      localStorage.setItem("databuilderQuery", this.lastSession);
      this.lastSession = null;
      this.reloadLastSession();
    }
  },
  data: () => ({
    lastSession: null,
    tabs: [{ name: "tab1", label: "Tab 1", id: "0" }],
    tab: "tab1",
    tabIndex: 1,
    tabColumns: [],
    tabSelectedColumns: [],
    tables: [],
    selectedTables: [],
    columns: [],
    columnCategories: [],
    clickedColumn: null,
    selectedColumns: [],
    columnsObjectArray: [],
    selectionCounter: 0,
    comparisonArray: [],
    operatorType: [],
    query: null,
    tableColumnDataId: null,
    loadingTable: false,
    loadingQueryTables: false,
    queryObject: {},
    tableObject: {},
    queryPartialSize: null,
    queryTotalSize: null,
    querySpentTime: null,
    selectedRule: null,
    aggrFields: aggregatorFields,
    fastDbTables: null,
    columnSearch: "",
    expandValue: 0,
    config: {
      operators: [
        {
          name: "AND",
          identifier: "AND",
        },
        {
          name: "OR",
          identifier: "OR",
        },
      ],
      rules: [],
      colors: [
        "#2D5270",
        "hsl(88, 50%, 55%)",
        "hsl(187, 100%, 45%)",
        "hsl(15, 100%, 55%)",
      ],
    },
    flexmonsterData: [],
    saveState: {
      name: null,
      description: null,
    },
    userSavedQueries: [],
  }),

  methods: {
    expand(direction) {
      if (direction === 1) {
        if (this.expandValue != 1) {
          this.expandValue = this.expandValue + 1;
        }
      } else {
        if (this.expandValue != -1) {
          this.expandValue = this.expandValue - 1;
        }
      }
    },
    addSelectedRule: function (rule) {
      this.selectedRule = rule;
    },
    buildQueryObject: async function () {
      LoadingModal.show();
      let queryObject = {
        table: this.selectedTables[0], //to fix later for dynamic tabs
        selectedColumns: this.columnsObjectArray,
        query: this.query,
      };

      try {
        let response = await BackendServices.postPivotDataRequest(queryObject);
        if (response.status === 204) {
          Feedback.warning("Sem dados para exibir");
        } else {
          this.flexmonsterData = response.data.data;
          this.queryPartialSize = response.data.partial_size;
          this.queryTotalSize = response.data.total_size;
          this.querySpentTime = response.data.spent_time;
        }
        LoadingModal.confirmationFlash();
        if (this.queryPartialSize < this.queryTotalSize) {
          Dialog.create({
            title: "Atenção",
            message:
              "A tabela está a mostrar " +
              this.queryPartialSize +
              " de " +
              this.queryTotalSize +
              " resultados.",
            persistent: true,
          });
        }
      } catch (error) {
        LoadingModal.errorFlash();
      }
    },
    toogleAggregator(column) {
      if (this.clickedColumn === column) {
        this.clickedColumn = null;
      } else {
        this.clickedColumn = column;
      }
    },
    addTab: function () {
      var i = this.tabs.length + 1;
      this.tabs.push({ name: `tab${i}`, label: `Tab ${i}`, id: i });
    },
    getQueryableTables: async function () {
      this.loadingQueryTables = true;
      let response = await BackendServices.getPivotFields();
      this.fastDbTables = response.data;
      for (let table in response.data) {
        this.tables.push(table);
      }
      this.tableObject = response.data;
      this.loadingQueryTables = false;
      this.selectedTables[0] = this.tables[0];
      this.createColumns();
      // {{ tableObject[selectedTables] }}
      // v-if="columns.filter( column => tableObject[selectedTables][column].related_pg_column == category).length > 0"
    },
    filterItems: function (arr) {
      //Return array without null keys from object arr
      return Object.keys(arr).filter(function (key) {
        return arr[key].label !== "null";
      });
    },
    createColumns: function () {
      this.selectedColumns = [];
      this.config.rules = [];
      this.query = null;
      this.columns = this.filterItems(this.tableObject[this.selectedTables]);
      // this.columns = Object.keys(this.tableObject[this.selectedTables]);
      this.tabIndex = parseInt(this.tab.slice(3), 10) - 1;

      for (var column in this.tableObject[this.selectedTables]) {
        if (this.tableObject[this.selectedTables][column].label === "null") {
          continue;
        }
        if (
          !this.columnCategories.includes(
            this.translateCategory(this.tableObject[this.selectedTables][column].related_pg_table)
          )
        ) {
          this.columnCategories.push(
            this.translateCategory(this.tableObject[this.selectedTables][column].related_pg_table)
          );
        }
        if (
          this.tableObject[this.selectedTables][column].type === "multi-select"
        ) {
          this.config.rules.push({
            identifier: column,
            name: this.tableObject[this.selectedTables][column].label,
            component: Multiselect,
          });
        }

        if (this.tableObject[this.selectedTables][column].type === "select") {
          this.config.rules.push({
            identifier: column,
            name: this.tableObject[this.selectedTables][column].label,
            component: Select,
          });
        }

        if (this.tableObject[this.selectedTables][column].type === "int") {
          this.config.rules.push({
            identifier: column,
            name: this.tableObject[this.selectedTables][column].label,
            related_pg_table:
              this.tableObject[this.selectedTables][column].related_pg_table,
            component: Int,
          });
        }

        if (
          this.tableObject[this.selectedTables][column].type === "float" ||
          this.tableObject[this.selectedTables][column].type === "double"
        ) {
          this.config.rules.push({
            identifier: column,
            name: this.tableObject[this.selectedTables][column].label,
            component: Decimal,
          });
        }

        if (this.tableObject[this.selectedTables][column].type === "string") {
          this.config.rules.push({
            identifier: column,
            name: this.tableObject[this.selectedTables][column].label,
            component: Textbox,
          });
        }

        if (this.tableObject[this.selectedTables][column].type === "date") {
          this.config.rules.push({
            identifier: column,
            name: this.tableObject[this.selectedTables][column].label,
            component: Date,
          });
        }

        if (this.tableObject[this.selectedTables][column].type === "boolean") {
          this.config.rules.push({
            identifier: column,
            name: this.tableObject[this.selectedTables][column].label,
            component: Boolean,
          });
        }
      }

      this.operatorType = [];
    },
    cleanQuerySelection: function () {
      //pass values from selectedColumns to selectedColumnsObjectArray
      this.selectedColumns = [];
      this.createColumns();
      this.query = null;
      this.selectedRule = null;
      this.columnSearch = "";
    },
    clearConfirmation: function () {
      Dialog.create({
        title: "Confirmação",
        message: "Deseja limpar todos os dados de pesquisa?",
        cancel: true,
        persistent: true,
      }).onOk(() => {
        this.cleanQuerySelection();
      });
    },
    translateCategory(category) {
      switch (category) {
        case "hierarchy_levels":
          return "Hierarquias";
        case "products":
          return "Produtos";
        case "stores":
          return "Lojas";
        case 'store_typologies':
          return "Lojas";
        case "ghost_stocks":
          return "Stock Fantasma";
        case "sellout_indicators":
          return "Vendas e Stocks";
        case "product_retailer_infos":
          return "Info RTL";
        case "employees":
          return "Vendedores";
        default:
          return category;
      }
    },
    saveQueryState() {
      let queryToSave = {
        table: this.tables[0], //TODO: same as buildQuery, will change when tabs get implemented
        queryColumns: this.columnsObjectArray,
        filters: this.query,
      };
      localStorage.setItem("databuilderQuery", JSON.stringify(queryToSave));
    },
    reloadLastSession() {
      let loadedQuery = JSON.parse(localStorage.getItem("databuilderQuery"));
      this.columnsObjectArray = loadedQuery.queryColumns;
      for (let i = 0; i < this.columnsObjectArray.length; i++) {
        this.selectedColumns.push(this.columnsObjectArray[i].id);
        this.columns = this.columns.filter(
          (e) => e != this.columnsObjectArray[i].id
        );
      }
      this.query = loadedQuery.filters;
      localStorage.removeItem("databuilderQuery");
    },
    openSaveModal() {
      this.getSavedQueriesList();
      this.$modal.show("saveQueryDialog");
    },
    autofillSaveFields(save) {
      this.saveState.name = save.name;
      this.saveState.description = save.description;
    },
    saveQueryToServer: async function () {
      let queryToSave = {
        name: this.saveState.name,
        description: this.saveState.description,
        query: {
          table: this.tables[0], //TODO: same as buildQuery, will change when tabs get implemented
          queryColumns: this.columnsObjectArray,
          filters: this.query,
        },
      };

      let response = await BackendServices.saveDatabuilderQuery(queryToSave);
      if (response.status === 200) {
        Feedback.success(response.data.message);
      } else {
        Feedback.error(response.data.message);
      }

      this.saveState.name = null;
      this.saveState.description = null;
      this.$modal.hide("saveQueryDialog");
    },
    discardSave() {
      this.saveState.name = null;
      this.saveState.description = null;
      this.$modal.hide("saveQueryDialog");
    },
    openSavedQueriesModal: function () {
      this.getSavedQueriesList();
      this.$modal.show("savedQueryList");
    },
    closeSavedQueriesList() {
      this.$modal.hide("savedQueryList");
    },
    getSavedQueriesList: async function () {
      let response = await BackendServices.getDatabuilderUserSavedQueries();
      this.userSavedQueries = response.data;
    },
    loadQuery: async function (id) {
      let response = await BackendServices.getSavedQueryById(id);
      if (response.status === 200) {
        this.cleanQuerySelection();
        let loadedQuery = response.data.save_object;
        this.columnsObjectArray = loadedQuery.queryColumns;
        for (let i = 0; i < this.columnsObjectArray.length; i++) {
          this.selectedColumns.push(this.columnsObjectArray[i].id);
          this.columns = this.columns.filter(
            (e) => e != this.columnsObjectArray[i].id
          );
        }
        this.query = loadedQuery.filters;
        this.closeSavedQueriesList();
        this.columnSearch = "";
      } else {
        Feedback.error("Erro a carregar pesquisa.");
      }
    },
    deleteQuery: async function (id) {
      let response = await BackendServices.deleteSavedQuery(id);
      if (response.status === 200) {
        this.getSavedQueriesList();
        Feedback.success(response.data.message);
      } else {
        Feedback.error(response.data.message);
      }
    },
    copyToClipboard: function (link) {
      navigator.clipboard.writeText(link);
      Feedback.success("Link copiado para a área de transferência.");
    },
    //category = 'ghost_stocks'
    checkEmpty: function (category) {
      let check = Object.entries(this.tableObject[this.selectedTables]).filter(
        (e) => this.columns.includes(e[0])
      );
      return check.map((e) => this.translateCategory(e[1].related_pg_table)).includes(this.translateCategory(category));
    },
  },
  watch: {
    columnSearch: {
      handler: function () {
        this.columns = this.filterItems(
          this.tableObject[this.selectedTables]
        ).filter((column) => column.includes(this.columnSearch.toLowerCase()));
      },
    },
    query: {
      deep: true,
      handler: function () {
        this.saveQueryState();
      },
    },
    columnsObjectArray: {
      deep: true,
      handler: function () {
        this.saveQueryState();
      },
    },
    selectedColumns: {
      deep: true,
      handler: function () {
        this.tabIndex = parseInt(this.tab.slice(3), 10);
        this.tabColumns[this.tabIndex] = this.columns;
        this.tabSelectedColumns[this.tabIndex] = this.selectedColumns;

        if (this.selectedColumns.length > this.selectionCounter) {
          this.selectionCounter = this.selectedColumns.length;
          let colFound = false;
          let sortedColumnsArray = [];
          for (let i = 0; i < this.selectedColumns.length; i++) {
            for (let j = 0; j < this.columnsObjectArray.length; j++) {
              if (this.selectedColumns[i] == this.columnsObjectArray[j].id) {
                sortedColumnsArray.push(this.columnsObjectArray[j]);
                colFound = true;
                break;
              }
            }
            if (colFound) {
              colFound = false;
              continue;
            } else {
              let type =
                this.tableObject[this.selectedTables][this.selectedColumns[i]]
                  .type;
              let relatedPgTable =
                this.tableObject[this.selectedTables][this.selectedColumns[i]]
                  .related_pg_table;
              let relatedPgColumn =
                this.tableObject[this.selectedTables][this.selectedColumns[i]]
                  .related_pg_column;
              let aggr = "value";
              if (
                (type == "int" || type == "double") &&
                relatedPgTable != "hierarchy_levels" &&
                relatedPgColumn != "date" &&
                relatedPgColumn != "file_upload_id"
              ) {
                aggr = "sum";
              } else {
                aggr = "value";
              }
              this.columnsObjectArray.push({
                id: this.selectedColumns[i],
                table_id:
                  this.tableObject[this.selectedTables][this.selectedColumns[i]]
                    .id,
                aggr: aggr,
              });
              sortedColumnsArray.push(
                this.columnsObjectArray[this.columnsObjectArray.length - 1]
              );
            }
          }
          this.columnsObjectArray = sortedColumnsArray;
        } else {
          if (this.selectedColumns.length < this.selectionCounter) {
            this.selectionCounter = this.selectedColumns.length;
            this.clickedColumn = null;
            for (var i = 0; i < this.columnsObjectArray.length; i++) {
              if (this.columnsObjectArray[i].id != this.selectedColumns[i]) {
                this.columnsObjectArray.splice(i, 1);
                i--;
              }
            }
          } else {
            let sortedColumnsArray = [];
            for (let i = 0; i < this.selectedColumns.length; i++) {
              for (let j = 0; j < this.columnsObjectArray.length; j++) {
                if (this.selectedColumns[i] == this.columnsObjectArray[j].id) {
                  sortedColumnsArray.push(this.columnsObjectArray[j]);
                  break;
                }
              }
            }
            this.columnsObjectArray = sortedColumnsArray;
          }
        }
      },
    },
    // tab: {
    //   deep: true,
    //   handler: function () {
    //     this.tabIndex = parseInt(this.tab.slice(3), 10);

    //     if (this.tabColumns[this.tabIndex]) {
    //       this.columns = this.tabColumns[this.tabIndex];
    //     } else {
    //       this.createColumns();
    //     }

    //     if (this.tabSelectedColumns[this.tabIndex]) {
    //       this.selectedColumns = this.tabSelectedColumns[this.tabIndex];
    //     } else {
    //       this.createColumns();
    //     }
    //   },
    // },
  },
  provide() {
    // return {
    //   columnId: () => this.tableColumnDataId,
    // };
  },
  computed: {
    canClear() {
      return this.query == null && this.columnsObjectArray[0] == undefined;
    },
    computedClass() {
      if (this.queryPartialSize < this.queryTotalSize) {
        return "row justify-center q-my-lg text-red";
      } else {
        return "row justify-center q-my-lg text-green";
      }
    },
    activeAggregationCard() {
      if (this.tableObject[this.selectedTables] != null) {
        return (
          this.tableObject[this.selectedTables][this.clickedColumn] != null
        );
      } else {
        return false;
      }
    },
  },
};
